/* eslint-disable react-hooks/exhaustive-deps */
import { useAlert } from "components/ui/alert-context";
import { Button } from "components/ui/button";
import { Checkbox } from "components/ui/checkbox";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { Switch } from "components/ui/switch";
import dayjs from "dayjs";
import { BankLog, Setting, VatInvoice } from "lib/models";
import React, { useEffect, useState } from "react";
import VatPaperPopup from "./VatPaperPopup";
import { apiPut } from "components/Common/Axios";

export enum ListType {
  readOnly, // 입출금내역 추가
  search, // 입출금내역 보기
  selectInput, // 입금내역 선택 (입금확인 Row click)
  selectInputMulti, // 여러개의 세금계산서에 한개의 입금내역 선택
  selectOutput,
}

interface BankLogCheck {
  checked: boolean;
  bankLog: BankLog;
}

const BankLogList = ({
  bankLogs,
  setBankLogs,
  listType,
  vatInvoice,
  vatInvoices,
  onOpenChange,
  onSelectComplete,
  onSelectCancel,
  setting,
}: {
  bankLogs: BankLog[];
  setBankLogs: (v: BankLog[]) => void;
  listType: ListType;
  vatInvoice?: VatInvoice;
  vatInvoices?: VatInvoice[];
  onOpenChange?: (v: boolean) => void;
  onSelectComplete?: (selectedBankLogs: BankLog[]) => void;
  onSelectCancel?: () => void;
  setting?: Setting;
}) => {
  // const [isIncludeInput, setIsIncludeInput] = useState(true);
  // const [isIncludeOutput, setIsIncludeOutput] = useState(true);
  const [isOnlyNotConnectedInput, setIsOnlyNotConnectedInput] = useState(true);
  const [isShowHidden, setIsShowHidden] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [isVatPaperOpen, setIsVatPaperOpen] = useState(false);
  const [selectedVatInvoices, setSelectedVatInvoices] = useState<VatInvoice[]>(
    []
  );
  const [totalBankLogCheck, setTotalBankLogCheck] = useState<BankLogCheck[]>(
    []
  );
  const [filteredBankLogsCheck, setFilteredBankLogsCheck] = useState<
    BankLogCheck[]
  >([]);

  const { show } = useAlert();

  const search = () => {
    const filtered = totalBankLogCheck.filter(
      (bankLogCheck) =>
        // ((isIncludeInput && bankLogCheck.bankLog.isInput) ||
        //   (isIncludeOutput && !bankLogCheck.bankLog.isInput)) &&
        bankLogCheck.bankLog.isInput &&
        (!(
          listType === ListType.selectInput ||
          listType === ListType.selectInputMulti
        ) ||
          // listType !== ListType.selectInput ||
          !isOnlyNotConnectedInput ||
          (!bankLogCheck.bankLog.vatInvoiceId &&
            !bankLogCheck.bankLog.bankLogMultiVatInvoice)) &&
        (isShowHidden || !bankLogCheck.bankLog.isHide)
    );

    if (keyword) {
      setFilteredBankLogsCheck(
        filtered.filter(
          (bankLogCheck) =>
            bankLogCheck.bankLog.depositName.includes(keyword) ||
            bankLogCheck.bankLog.myDescription.includes(keyword) ||
            bankLogCheck.bankLog.description.includes(keyword) ||
            bankLogCheck.bankLog.branch.includes(keyword)
        )
      );
    } else {
      setFilteredBankLogsCheck(filtered);
    }
  };

  useEffect(() => {
    setTotalBankLogCheck(
      bankLogs.map((log) => ({
        checked:
          vatInvoice?.bankLogs?.some(
            (vatBankLog) => vatBankLog.id === log.id
          ) ?? false,
        bankLog: log,
      }))
    );
  }, [bankLogs]);

  useEffect(() => {
    search();
  }, [
    // isIncludeInput,
    // isIncludeOutput,
    isOnlyNotConnectedInput,
    isShowHidden,
    keyword,
    totalBankLogCheck,
  ]);

  useEffect(() => {
    // if (listType === ListType.readOnly) {
    //   // setIsIncludeInput(true);
    //   // setIsIncludeOutput(true);
    //   setKeyword("");
    // } else if (listType === ListType.selectInput) {
    //   // setIsIncludeInput(true);
    //   // setIsIncludeOutput(false);
    //   setKeyword("");
    // } else if (listType === ListType.selectOutput) {
    //   // setIsIncludeInput(false);
    //   // setIsIncludeOutput(true);
    //   setKeyword("");
    // }
    // setIsIncludeInput(true);
    // setIsIncludeOutput(false);
    setKeyword("");
  }, [listType]);

  useEffect(() => {
    // selectInput모드인데 입금내역이 있으면 "세금계산서와 연결되지 않은 것만"의 체크를 푼다
    if (
      (listType === ListType.selectInput ||
        listType === ListType.selectInputMulti) &&
      (vatInvoice?.bankLogs?.length ?? 0) > 0
    ) {
      setIsOnlyNotConnectedInput(false);
      search();
    }
  }, [listType, vatInvoice]);

  const onSelectInputComplete = async () => {
    const selectedBankLogs = filteredBankLogsCheck
      .filter((log) => log.checked)
      .map((log) => log.bankLog);

    const existOtherInvoice = selectedBankLogs.some(
      (log) => !!log.vatInvoiceId && log.vatInvoiceId !== vatInvoice?.id
    );
    if (existOtherInvoice) {
      show("확인", "다른 세금계산서와 연결된 통장내역이 있습니다.", "alert");
      return;
    }

    onSelectComplete?.(selectedBankLogs);
  };

  const onHideBankLog = async (bankLog: BankLog, checked: boolean) => {
    const response = await apiPut("/bank/hide", {
      bankLogId: bankLog.id,
      isHide: checked,
    });

    if (response.error) {
      show("오류", "통장내역 감추기에 실패했습니다.", "alert");
      return;
    }

    const newBankLogs = bankLogs.map((log) =>
      log.id === bankLog.id ? { ...log, isHide: checked } : log
    );
    setBankLogs(newBankLogs);

    setTotalBankLogCheck(
      newBankLogs.map((log) => ({
        checked:
          vatInvoice?.bankLogs?.some(
            (vatBankLog) => vatBankLog.id === log.id
          ) ?? false,
        bankLog: log,
      }))
    );
  };

  return (
    <div className="">
      {!!setting && (
        <VatPaperPopup
          open={isVatPaperOpen}
          onOpenChange={setIsVatPaperOpen}
          vatInvoices={selectedVatInvoices}
          totalVatInvoiceCheck={[]}
          setTotalVatInvoiceCheck={() => {}}
          setting={setting!}
          isApplyMode={false}
          isReadOnly={true}
          isShowAddOverlay={true}
        />
      )}
      {listType === ListType.selectInput && (
        <div className="border border-solid border-gray-300 rounded-md px-3 py-2 mb-6 overflow-x-auto">
          <div className="min-w-[760px]">
          <div className="grid grid-cols-[1fr_1fr_1fr_2fr_1fr_1fr_1fr] bg-gray-50 text-gray-500 font-medium p-2">
            <div>거래처명</div>
            <div>발급처명</div>
            <div>입금자명</div>
            <div>품목명</div>
            <div className="text-right">총액</div>
            <div className="text-right">입금액</div>
            <div className="text-center">발급일</div>
          </div>
          <div className="grid grid-cols-[1fr_1fr_1fr_2fr_1fr_1fr_1fr] p-2">
            <div>{vatInvoice?.vatCompany?.nickName ?? "none"}</div>
            <div>{vatInvoice?.vatCompany?.name ?? "none"}</div>
            <div>{vatInvoice?.vatCompany?.depositName}</div>
            <div>{vatInvoice?.supplyContent1}</div>
            <div className="text-right">
              {vatInvoice?.totalAmt?.toLocaleString()}원
            </div>
            <div className="text-right">
              {vatInvoice?.depositAmt?.toLocaleString()}원
            </div>
            <div className="text-center">
              {dayjs(vatInvoice?.issuedDate).toDate().toLocaleDateString()}
            </div>
          </div>
          </div>
        </div>
      )}

      {listType === ListType.selectInputMulti && (
        <div className="border border-solid border-gray-300 rounded-md px-3 py-2 mb-6 overflow-x-auto">
          <div className="min-w-[760px]">
          <div className="grid grid-cols-[1fr_1fr_1fr_2fr_1fr_1fr_1fr] bg-gray-50 text-gray-500 font-medium p-2">
            <div>거래처명</div>
            <div>발급처명</div>
            <div>입금자명</div>
            <div>품목명</div>
            <div className="text-right">총액</div>
            <div className="text-right">입금액</div>
            <div className="text-center">발급일</div>
          </div>
          {vatInvoices?.map((vatInvoice) => (
            <div
              key={vatInvoice.id}
              className="grid grid-cols-[1fr_1fr_1fr_2fr_1fr_1fr_1fr] p-2"
            >
              <div>{vatInvoice?.vatCompany?.nickName ?? "none"}</div>
              <div>{vatInvoice?.vatCompany?.name ?? "none"}</div>
              <div>{vatInvoice?.vatCompany?.depositName}</div>
              <div>{vatInvoice?.supplyContent1}</div>
              <div className="text-right">
                {vatInvoice?.totalAmt?.toLocaleString()}원
              </div>
              <div className="text-right">
                {vatInvoice?.depositAmt?.toLocaleString()}원
              </div>
              <div className="text-center">
                {dayjs(vatInvoice?.issuedDate).toDate().toLocaleDateString()}
              </div>
            </div>
          ))}
          </div>
        </div>
      )}

      {listType !== ListType.readOnly && (
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-2">
          <div>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 pb-2">
              {(listType === ListType.selectInput ||
                listType === ListType.selectInputMulti) && (
                <>
                  <div className="flex items-center gap-2">
                    <Switch
                      checked={isOnlyNotConnectedInput}
                      onCheckedChange={(checked) => {
                        setIsOnlyNotConnectedInput(checked);
                      }}
                      id="setIsOnlyNotConnectedInput"
                    />
                    <Label htmlFor="setIsOnlyNotConnectedInput">
                      세금계산서와 연결되지 않은 것만
                    </Label>
                  </div>
                  <div className="flex items-center gap-2">
                    <Switch
                      checked={isShowHidden}
                      onCheckedChange={(checked) => {
                        setIsShowHidden(checked);
                      }}
                      id="setIsShowHidden"
                    />
                    <Label htmlFor="setIsShowHidden">감춘 내역도 보기</Label>
                  </div>
                </>
              )}

              <Input
                className="border border-gray-300 px-2 py-1 rounded-sm w-full sm:w-40"
                placeholder="검색어를 입력하세요"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>
          </div>
          <div>
            {(listType === ListType.selectInput ||
              listType === ListType.selectInputMulti) && (
              <div>
                총액 :{" "}
                {filteredBankLogsCheck
                  .filter((log) => log.checked)
                  .reduce((acc, cur) => acc + cur.bankLog.depositAmt, 0)
                  .toLocaleString()}
                원
              </div>
            )}
          </div>
        </div>
      )}
      <div className="overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0">
      <div className="min-w-[1200px]">
        <div className="py-2 mt-1 text-sm text-left grid items-center grid-cols-[60px_140px_160px_140px_100px_1fr_180px_120px_100px_80px] bg-gray-200">
          <div className="text-center">번호</div>
          <div className="text-center">거래일시</div>
          <div>보낸분/받는분</div>
          <div className="text-right">금액</div>
          <div className="text-center">입금/출금</div>
          <div>내통장표시</div>
          <div>적요</div>
          <div>처리점</div>
          <div className="text-center">세금계산서</div>
          <div>감춤</div>
        </div>
        {/* <div className="max-h-[500px] overflow-y-auto thin-scrollbar"> */}
        <div>
          {filteredBankLogsCheck.map((bankLogCheck, index) => (
            <div
              key={bankLogCheck.bankLog.id}
              className={`py-3 border-b border-solid border-gray-300 text-sm text-left grid items-center grid-cols-[60px_140px_160px_140px_100px_1fr_180px_120px_100px_80px] cursor-pointer hover:bg-gray-50 ${
                // bankLogCheck.bankLog.isInput &&
                // listType !== ListType.selectInput
                //   ? "text-green-600 font-semibold"
                //   : "text-gray-800"
                "text-gray-800"
              } ${
                // 같은 금액을 강조표시
                listType === ListType.selectInput
                  ? bankLogCheck.bankLog.isInput &&
                    bankLogCheck.bankLog.vatInvoiceId
                    ? bankLogCheck.bankLog.vatInvoiceId === vatInvoice?.id
                      ? bankLogCheck.bankLog.depositAmt === vatInvoice?.totalAmt
                        ? "bg-green-600 text-white" // 내 계산서 (딱 맞는 금액)
                        : "bg-red-300 text-white" // 내 계산서 (일치하지 않는 금액)
                      : "text-[#aaa]" // 다른 계산서
                    : bankLogCheck.bankLog.depositAmt === vatInvoice?.totalAmt
                    ? "text-orange-600 font-semibold" // 계산서와 연결되지 않고 딱 맞는 금액
                    : ""
                  : listType === ListType.selectInputMulti &&
                    bankLogCheck.bankLog.bankLogMultiVatInvoice?.vatInvoices
                  ? bankLogCheck.bankLog.bankLogMultiVatInvoice?.vatInvoices.some(
                      (s) => vatInvoices?.some((v) => v.id === s.id)
                    )
                    ? "bg-green-600 text-white"
                    : "text-[#aaa]"
                  : bankLogCheck.bankLog.depositAmt ===
                    vatInvoices?.reduce((acc, cur) => acc + cur.totalAmt, 0)
                  ? "text-orange-600 font-semibold"
                  : ""
              }`}
            >
              <div className="text-center flex justify-center items-center gap-2">
                {(listType === ListType.selectInput ||
                  listType === ListType.selectInputMulti) && (
                  <Checkbox
                    className="data-[state=checked]:bg-indigo-600 data-[state=checked]:border-indigo-600"
                    checked={bankLogCheck.checked}
                    onCheckedChange={(checked: boolean) => {
                      const newTotalBankLogCheck = totalBankLogCheck.map(
                        (log) => {
                          return log.bankLog.id === bankLogCheck.bankLog.id
                            ? { ...log, checked }
                            : log;
                        }
                      );

                      setTotalBankLogCheck(newTotalBankLogCheck);
                    }}
                    disabled={
                      !!bankLogCheck.bankLog.vatInvoiceId &&
                      bankLogCheck.bankLog.vatInvoiceId !== vatInvoice?.id
                    }
                  />
                )}
                <div>{index + 1}</div>
              </div>
              <div className="text-center">
                {dayjs(bankLogCheck.bankLog.depositDate)
                  .toDate()
                  .toLocaleDateString()}
              </div>
              <div>{bankLogCheck.bankLog.depositName}</div>
              <div className="text-right">
                {bankLogCheck.bankLog.depositAmt.toLocaleString()}
              </div>
              <div className="text-center">
                {bankLogCheck.bankLog.isInput ? "입금" : "출금"}
              </div>
              <div>{bankLogCheck.bankLog.myDescription}</div>
              <div>{bankLogCheck.bankLog.description}</div>
              <div>{bankLogCheck.bankLog.branch}</div>
              <div className="flex justify-center">
                {bankLogCheck.bankLog.vatInvoiceId ? (
                  <div
                    className="bg-indigo-100 text-indigo-700 font-medium rounded-md w-12 mx-auto text-center"
                    onClick={() => {
                      setSelectedVatInvoices([
                        bankLogCheck.bankLog.vatInvoice!,
                      ]);
                      setIsVatPaperOpen(true);
                    }}
                  >
                    계산서
                  </div>
                ) : bankLogCheck.bankLog.bankLogMultiVatInvoice ? (
                  <div
                    className="bg-indigo-100 text-indigo-700 font-medium rounded-md w-12 mx-auto text-center"
                    onClick={() => {
                      if (bankLogCheck.bankLog.bankLogMultiVatInvoice) {
                        setSelectedVatInvoices(
                          bankLogCheck.bankLog.bankLogMultiVatInvoice
                            .vatInvoices
                        );
                        setIsVatPaperOpen(true);
                      }
                    }}
                  >
                    계산서
                  </div>
                ) : null}
              </div>
              <div>
                <Checkbox
                  className="data-[state=checked]:bg-rose-500 data-[state=checked]:border-rose-500"
                  checked={bankLogCheck.bankLog.isHide}
                  onCheckedChange={(checked: boolean) =>
                    onHideBankLog(bankLogCheck.bankLog, checked)
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      </div>
      {(listType === ListType.selectInput ||
        listType === ListType.selectInputMulti) && (
        <div className="flex flex-wrap justify-between pt-4 gap-2">
          <div>
            {(vatInvoice?.bankLogs?.length ?? 0) > 0 && onSelectCancel && (
              <Button variant="destructive" onClick={() => onSelectCancel()}>
                입금선택취소
              </Button>
            )}
          </div>
          <div className="flex justify-between gap-2">
            <Button variant="primary" onClick={() => onSelectInputComplete()}>
              입금선택완료
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                if (onOpenChange) {
                  onOpenChange(false);
                }
              }}
            >
              취소
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BankLogList;
